import { styled, ToggleButtonGroup, toggleButtonGroupClasses } from '@mui/material';
import { EL_COLORS } from '@/colors';
import type { AppToggleButtonMode } from './AppToggleButton';

export const AppToggleButtonGroup = styled(ToggleButtonGroup, {
  shouldForwardProp: (prop) => prop !== 'mode',
})<{ mode?: AppToggleButtonMode }>(({ theme, mode }) => {
  if (mode === 'contained') {
    return {
      display: 'flex',
      justifyContent: 'space-between',
      height: 24,
      border: `1px solid ${EL_COLORS.BoxBorder}`,
      borderRadius: theme.spacing(0.5),
      [`& .${toggleButtonGroupClasses.grouped}`]: {
        border: 'none',
        '&:hover': {
          border: 'none',
        },
        [`&.${toggleButtonGroupClasses.disabled}`]: {
          border: 'none',
        },
      },
      [`& .${toggleButtonGroupClasses.middleButton}`]: {
        marginLeft: 0,
      },
    };
  }
  if (mode === 'group') return {};

  return {
    [`& .${toggleButtonGroupClasses.grouped}`]: {
      margin: theme.spacing(0.25),
      border: 0,
      borderRadius: theme.spacing(0.5),
      [`&.${toggleButtonGroupClasses.disabled}`]: {
        border: 0,
      },
    },
  };
});
